import MarkdownIt from 'markdown-it'
import markdownItKatex from 'markdown-it-katex'
import mathjax3 from 'markdown-it-mathjax3';

// export default new MarkdownIt({
// 	breaks: true, // 关键！启用换行解析
// 	html: true, ///允许渲染html标签
// 	linkify: true, ///自动识别网址并转换为链接
// 	highlight: function(str, lang) {
// 		return `<pre class="lfe-code"><code>${str}</code></pre>`
// 	}
// }).use(markdownItKatex, {
// 	strict: false, // 允许非严格模式解析
// 	throwOnError: false,
// 	output: "html", // 输出模式：mathml（原生数学标记）或html（CSS渲染
// 	delimiters: [{
// 			left: '$$',
// 			right: '$$',
// 			display: true
// 		}, // 块级公式模式
// 		{
// 			left: "$",
// 			right: "$",
// 			display: false
// 		} // 行内公式
// 	],
// })
// 1. 定义一个只负责设置validateLink的插件
const setFinalValidateLink = (md) => {
  // 这个函数会在.use()时被调用，传入当前的md实例
  md.validateLink = function(url) {
    if (url.endsWith('.in') || url.endsWith('.out')) {
      return false;
    }
    return true;
  };
  // 也可以选择不修改原型，只修改当前实例
  // md.__proto__.validateLink = function(...){...}
};
const newmd = new MarkdownIt({
	breaks: true, // 关键！启用换行解析
	html: true, ///允许渲染html标签
	linkify: false, ///自动识别网址并转换为链接
	highlight: function(str, lang) {
		return `<pre class="lfe-code"><code>${str}</code></pre>`
	},
	// // 自定义链接验证规则，阻止特定模式被识别为链接
	// validateLink: function (url) {
	// 	console.log("validateLink",url)
	//     // 例如，阻止所有以 `.in` 或 `.out` 结尾的“链接”
	//     if (url.endsWith('.in') || url.endsWith('.out')) {
	// 		//console.log(url)
	//         return false;
	//     }
	//     // 其他链接正常处理
	//     return true;
	// },
}).use(mathjax3).use(setFinalValidateLink); // 我们的插件最后执行，进行“终审”
// 自定义链接验证规则，阻止特定模式被识别为链接
// newmd.validateLink = function (url) {
//     // 例如，阻止所有以 `.in` 或 `.out` 结尾的“链接”
//     if (url.endsWith('.in')) {
//         return false;
//     }
//     // 其他链接正常处理
//     return true;
// };

export default newmd;